export const RETRIEVING_NFT = "Claiming your NFT Items ...";
export const ALCHEMY_ERROR_MSG = [
    "There was an error retrieving your NFT Items from the network.",
    "Please try again."
];
export const METADATA_ERROR_MSG = [
    "There was an error retrieving your NFT Metadata./n Please try again.",
    "Please try again."
];
export const BUTTON_ERROR_MSG = "Return to Claim Screen."
export const ERROR_NAVIGATE_URL = "/claim";